import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { MdOutlineLaunch } from 'react-icons/md';


import Page from 'src/components/Page';
import agm from '../../services/agm'

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Inventory from './Inventory';
import Create from './Create';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: -1,
  ordem: '',
  numero: '',
  fornecedor: '',
  dataEmissao: null,
  anotacao: '',
  valorLiquido: 0.0,
  valorImposto: 0.0,
  valorAjuste: 0.0,
  total: 0.0,
  fase: 1,
  idProduto: '',
  qtdProduto: '',
  codigoProduto: '',
  nomeProduto: '',
  lpuProduto: '',
  custoProduto: '',
  bdiProduto: '',
  valorProduto: '',
  instalacaoProduto: '',
  produto: null
}

const defaultDependencies = {
  loaded: false,
  items: [],
  removes: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Data', field: 'formatDatetime(item.data)', size: 120, sortable: "data", exportable: 0, wrap: 1 },
  { name: 'Código', field: 'item.produto.codigo', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Produto', field: 'item.produto.nome', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Estoque', field: 'item.estoque.nome', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Anotação', field: '(item.lancamento) ? item.lancamento.anotacao : item.anotacao', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Tipo', field: '(item.lancamento) ? "Manual" : "Automático" ', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Ordem', field: '(item.lancamento) ? formatNumber(item.lancamento.ordem, "00000") : "" ', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Operação', field: '((item.aberto) ? "Aberto" : (item.qtd > 0) ? "Carregado" : "Baixado")', size: -1, sortable: 0, exportable: 0, wrap: 0 }
];

const defaultEmptyMessage = "Nenhuma Entrada de Estoque Foi Encontrada.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Lançamentos de Produtos no Estoque', refine: 1, label: 'Produtos', history: 1 },
  { id: 2, name: 'Histórico de Lançamentos por Produto', refine: 1, label: 'Produtos', history: 1 },
  { id: 3, name: 'Histórico de Lançamentos por Anotação', refine: 1, label: 'Anotação', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  stock: -1,
  visao: defaultVisions[0]
}

const Inventories = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = (item) => {
    setItem(item);
  }

  const openCreation = (item) => {
    setItem(item);
    agm.get('/notas/dependencias/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          items: response.data.itens,
          removes: []
        });
        item.ordem = response.data.proximaNota.valor;
        item.idProduto = '';
        item.qtdProduto = '';
        item.codigoProduto = '';
        item.nomeProduto = '';
        item.lpuProduto = '';
        item.custoProduto = '';
        item.bdiProduto = '';
        item.valorProduto = '';
        item.instalacaoProduto = '';
        item.produto = null;
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Entrada no Estoque',
      message: 'Deseja excluir o lançamento de Entrada no Estoque selecionado?',
      warn: 'Esta ação irá tentar ajustar o estoque caso o lançamento já tenha sido contabilizado. Caso não seja possível corrigir o estoque a operação não será completada.'
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({
      title: 'Entrada no Estoque',
      message: 'Deseja Efetuar o registro do Lançamento no estoque?',
      warn: 'Esta ação irá Atualizar os Valores de Estoque dos Produtos Adicionados no Lançamento.'
    });
    setOpenTreatmentDialog(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    agm.put('/notas/tratamento/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeTreatment();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  }

  const updateValues = (values, items, removes) => {
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    agm.put('/notas/' + values.id, { nota: values, itens: items, remover: removes, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const createValues = (values, items) => {
    agm.post('/notas', { nota: values, itens: items }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const deleteValues = (values) => {
    agm.delete('/notas/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const refreshItems = () => {
    agm.post('/notas/historico', { filtro: filter }, {
    }).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post('/notas/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
    })
  }


  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows, stock) => {
    var value = {
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      stock: stock,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    agm.post('/notas/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  return (
    <Page
      className={classes.root}
      title="Lançamentos"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={MdOutlineLaunch}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Inventory item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultset={state}
                resultModes={resultModes}
                icon={MdOutlineLaunch}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                changeSort={changeSort}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default Inventories;